import {Button, Col, Form, Input, InputNumber, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import TranslationInput from "../../../../../shared/input/TranslationInput";
import Utils from "../../../../../../utils";
import IField, {FIELD_FLOAT_TYPES} from "../../../../../../model/interface/dataStorage/IField";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import HumanTimeConfigBuilder, {IHumanTimeConfig} from "../../../../../shared/human-time/HumanTimeConfigBuilder";

export interface IFieldNumberOptions {
    numberMinValue?: number,
    numberMaxValue?: number,
    numberMinWidth?: number,
    numberFullWidth?: boolean
    numberPrecision?: number
}

interface IProps extends IFieldOptionsEditorProps {
    field: IField
}

interface IState {
}

class FieldNumberOptionsEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {buildFieldName, field} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('numberMinValue')} label={<LocaleText code={'configuration.field.number.option.min-value'} fallback={'Minimální hodnota'}/>}>
                    <InputNumber/>
                </Form.Item>
                <Form.Item name={buildFieldName('numberMaxValue')} label={<LocaleText code={'configuration.field.number.option.max-value'} fallback={'Maximální hodnota'}/>}>
                    <InputNumber width={'100%'}/>
                </Form.Item>
                <Form.Item label={<LocaleText code={'configuration.field.number.option.min-width'}  fallback={'Minimální šířka'}/>}>
                    <Input.Group className={'d-flex'} compact>
                        <Form.Item name={buildFieldName('numberMinWidth')} noStyle>
                            <InputNumber min={1}/>
                        </Form.Item>
                        <Form.Item noStyle>
                            <Button disabled>px</Button>
                        </Form.Item>
                    </Input.Group>
                </Form.Item>
                <Form.Item name={buildFieldName('numberFullWidth')} label={<LocaleText code={'configuration.field.number.option.full-width'} fallback={'Plná šířka'}/>} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={buildFieldName('numberTimeFormat')} label={<LocaleText code={'configuration.field.number.option.time-format'} fallback={'Format'}/>}   rules={[{
                    required: false,
                    validator: async (rule, value: IHumanTimeConfig) => {
                        if (value && (!value.interval || !value.format) && !(!value.interval && !value.format)) {
                            throw new Error('Invalid config')
                        }
                    }
                }]}>
                    <HumanTimeConfigBuilder/>
                </Form.Item>
                {FIELD_FLOAT_TYPES.includes(field.type) && (
                    <Form.Item label={'Zaokrouhlit na'} name={buildFieldName('numberPrecision')}>
                        <InputNumber min={0} max={Number.MAX_SAFE_INTEGER}/>
                    </Form.Item>
                )}
            </div>
        )
    }
}


export default FieldNumberOptionsEditor